import React from 'react';
import { PrivacyPolicy } from './components/PrivacyPolicy';
export function App() {
  return <PrivacyPolicy data-id="element-0" />;
}